<template>
  <b-modal
    id="select-for-group-post-creation"
    :modal-class="'default-modal modal-small'"
    :hide-footer="true"
    ref="selectGroupPostCreation"
    @shown="shown"
    @hidden="hidden"
  >
    <template v-slot:modal-title>
      Selecione uma comunidade
    </template>

    <template v-slot:default>
      <AlertWraper
        :content="errors"
        type="error"
      />
      <div class="text-center">
        <div v-if="groups.length === 0 && loader">
          <Loader
            color="color2"
            size="big"
          />
        </div>
        <div v-else-if="groups.length > 0">
          <ul>
            <li
              v-for="group in groups"
              :key="group.id"
            >
              <router-link
                :to="{ name: 'groups.posts.create', params: { groupSlug: group.slug } }"
                @click.native="$bvModal.hide('select-for-group-post-creation')"
              >
                <div
                  class="d-flex align-items-center item rounded-regular p-2"
                >
                  <div
                    class="image rounded-regular background-cover"
                    :style="{ backgroundImage: `url('${group.cover}')` }"
                  ></div>
                  <div class="content pl-2 d-flex align-items-center text-left">
                    <span class="font-size-small text-color1">{{ group.name }}</span>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
          <div>
            <Button
              class="btn-outline-color2 btn-sm"
              @click="loadMore"
              :loading="loader"
              v-if="isLoadMoreVisible"
            >
              Carregar mais
            </Button>
          </div>
        </div>
        <div
          class="font-size-small"
          v-else
        >
          <p>Não foram encontradas comunidades</p>
          <router-link
            class="btn btn-outline-color2 btn-sm mt-1"
            :to="{ name: 'groups.create' }"
            @click.native="$bvModal.hide('select-for-group-post-creation')"
          >
            Criar uma comunidade
          </router-link>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>

import GroupsService from '@/modules/groups/services/groups-service'
import { parseErrorResponseToArray } from '@/utils'
import { mapState } from 'vuex'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'

export default {
  name: 'SelectGroupPostCreationModal',
  components: {
    AlertWraper,
    Button,
    Loader
  },
  data () {
    return {
      errors: null,
      loader: false,
      isLoadMoreVisible: true,
      page: 1,
      groups: []
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    })
  },
  methods: {
    async getGroups () {
      this.loader = true
      try {
        const groups = await GroupsService.getGroups({ userId: this.user.id, page: this.page })
        this.groups = [...this.groups, ...groups]
        this.isLoadMoreVisible = groups.length > 0
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    loadMore () {
      this.page++
      this.getGroups()
    },
    shown () {
      this.reset()
      this.getGroups()
    },
    reset () {
      this.errors = null
      this.page = 1
      this.groups = []
    },
    hidden () {
      this.reset()
      this.$bvModal.hide('select-for-group-post-creation')
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  transition: all 0.2s ease-out;
  cursor: pointer;

  &:hover {
    background: $color6;
  }
}
.image {
  width: 60px;
  height: 40px;
}
.content {
  flex-grow: 1;
}

</style>
